export const getUsuario = (state) => {
    return state.usuario;
 };
 